import { apiService } from './apiService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api';

export type ChannelPreference = 'chat' | 'email' | 'both' | null;

export interface AgentConfig {
  user_id: number;
  profile_id: number;
  enabled: boolean;
  proactive_enabled: boolean;
  channel_preference: ChannelPreference;
  daily_proactive_limit: number | null;
  weekly_proactive_limit: number | null;
  min_minutes_between_interactions: number | null;
  quiet_hours_start: string | null;
  quiet_hours_end: string | null;
  persona_overrides: Record<string, any>;
  updated_at: string;
}

export type AgentConfigUpdate = Partial<Omit<AgentConfig, 'user_id' | 'profile_id' | 'updated_at'>>;

export interface AgentSettings {
  globally_enabled: boolean;
  scheduler_interval_minutes: number;
  default_daily_proactive_limit: number;
  default_weekly_proactive_limit: number;
  default_min_minutes_between_interactions: number;
  default_quiet_hours_start: string;
  default_quiet_hours_end: string;
  default_channel_preference: 'chat' | 'email' | 'both';
  max_tool_iterations: number;
  max_input_tokens_estimate: number;
  last_scheduler_tick_at: string | null;
  updated_at: string;
}

export type AgentSettingsUpdate = Partial<Omit<AgentSettings, 'last_scheduler_tick_at' | 'updated_at'>>;

export const agentService = {
  getConfig: async (userId: number): Promise<AgentConfig> => {
    return apiService.get(`${API_BASE_URL}/agent/configs/${userId}/`);
  },

  updateConfig: async (userId: number, data: AgentConfigUpdate): Promise<AgentConfig> => {
    return apiService.patch(`${API_BASE_URL}/agent/configs/${userId}/`, data);
  },

  getSettings: async (): Promise<AgentSettings> => {
    return apiService.get(`${API_BASE_URL}/agent/settings/`);
  },

  updateSettings: async (data: AgentSettingsUpdate): Promise<AgentSettings> => {
    return apiService.patch(`${API_BASE_URL}/agent/settings/`, data);
  },
};
